// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalsList_professionals__6T19v {
  max-width: 1280px;
  margin: 0 auto;
  padding: 32px 40px 88px;
  background-color: transparent;
  --bw-grid-search-axis: 40px;
}
@media (max-width: 1164px) {
  .ProfessionalsList_professionals__6T19v {
    --bw-grid-search-axis: 28px;
  }
}
@media (max-width: 860px) {
  .ProfessionalsList_professionals__6T19v {
    padding: 24px 20px 60px;
  }
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_utility-bar__ZlqXB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_back__ekJog {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 14px;
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: rgba(248, 244, 240, 0.92);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.03);
  text-decoration: none;
  color: #13231D;
  font-size: 14px;
  font-weight: 800;
  transition: all 0.2s ease;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_back__ekJog:hover {
  background: #fff;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professional-search-flow__qKXrV {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professional-search-flow__qKXrV .ProfessionalsList_search-holder__c3enG {
  order: 1;
  margin: 0;
  padding: 0;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professional-search-flow__qKXrV .ProfessionalsList_professional-results__qN1mE {
  order: 2;
  margin: 0;
  padding: 0;
  scroll-margin-top: 20px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professional-search-flow__qKXrV.ProfessionalsList_is-search-active__pefa4 .ProfessionalsList_professional-results__qN1mE {
  order: 1;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professional-search-flow__qKXrV.ProfessionalsList_is-search-active__pefa4 .ProfessionalsList_search-holder__c3enG {
  order: 2;
  margin-top: 24px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professional-search-flow__qKXrV.ProfessionalsList_is-search-active__pefa4 .ProfessionalsList_grid-wrap__p-A2w {
  margin-top: 28px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-actions__hogZC {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  margin: 0 0 12px;
  padding-left: var(--bw-grid-search-axis);
  padding-right: var(--bw-grid-search-axis);
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-actions__count__Wi5UB {
  margin: 0;
  align-self: center;
  min-width: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  color: var(--bw-text-secondary, #617067);
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-actions__buttons__s1MmI {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action__rtsWB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 17px;
  border: 1px solid var(--bw-primary, #82B194);
  border-radius: var(--bw-control-radius, 14px);
  background: transparent;
  color: var(--bw-text, #13231D);
  font: 600 13px/1.4 "Sora", system-ui, -apple-system, sans-serif;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: all 0.2s ease;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action__rtsWB:hover {
  background: rgba(130, 177, 148, 0.09);
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action__rtsWB:focus-visible {
  outline: 2px solid var(--bw-primary, #82B194);
  outline-offset: 3px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action--clear__zgqp4 {
  min-height: 24px;
  padding: 0 2px;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  color: var(--bw-text, #13231D);
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action--clear__zgqp4:hover {
  background: transparent;
  color: var(--bw-primary-active, #527963);
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__Q\\+DHq {
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: clamp(28px, 3.6vw, 44px) var(--bw-grid-search-axis) clamp(30px, 3.6vw, 44px);
  width: 100%;
  max-width: 100%;
  background: transparent;
  text-align: left;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__copy__u9God {
  min-width: 0;
  max-width: 760px;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__count__atO0T {
  display: block;
  margin: 0 0 10px;
  color: var(--bw-primary, #82B194);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__Q\\+DHq h2 {
  max-width: 580px;
  margin: 0;
  color: var(--bw-text, #13231D);
  font-size: clamp(28px, 2.5vw, 36px);
  line-height: 1.22;
  letter-spacing: -0.035em;
  font-weight: 700;
  text-wrap: balance;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__description__oJCB2 {
  max-width: 650px;
  margin: 14px 0 0;
  color: var(--bw-text-secondary, #617067);
  font-size: clamp(15px, 1.15vw, 17px);
  line-height: 1.6;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__actions__A7-OR {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin: 0;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__primary__AH7LF {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 46px;
  padding: 0 23px;
  border: 1px solid var(--bw-primary, #82B194);
  border-radius: var(--bw-control-radius, 14px);
  background: var(--bw-primary, #82B194);
  color: #fff;
  font: 700 14px/1.3 "Sora", system-ui, -apple-system, sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__primary__AH7LF:hover {
  background: var(--bw-primary-hover, #709D83);
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__primary__AH7LF:focus-visible {
  outline: 2px solid var(--bw-primary);
  outline-offset: 3px;
}
@media (max-width: 840px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__Q\\+DHq {
    gap: 20px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__actions__A7-OR {
    justify-content: flex-start;
  }
}
@media (max-width: 560px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__Q\\+DHq {
    padding: 24px var(--bw-grid-search-axis) 30px;
    gap: 16px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__Q\\+DHq h2 {
    font-size: clamp(26px, 6vw, 32px);
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__description__oJCB2 {
    margin-top: 12px;
    font-size: 15px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__actions__A7-OR {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_empty-results__primary__AH7LF {
    width: 100%;
  }
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-footer__qBgD\\+ {
  margin: 22px 0 0;
  padding-left: var(--bw-grid-search-axis);
  padding-right: var(--bw-grid-search-axis);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-footer__qBgD\\+ .ProfessionalsList_grid-count__IyXSg {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  color: var(--bw-text-secondary, #617067);
}
@media (max-width: 560px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-footer__qBgD\\+ {
    margin-top: 17px;
  }
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-wrap__p-A2w {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 288px));
  gap: 16px;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 20px;
}
@media (max-width: 1180px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-wrap__p-A2w {
    grid-template-columns: repeat(3, minmax(0, 288px));
  }
}
@media (max-width: 980px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-wrap__p-A2w {
    grid-template-columns: repeat(2, minmax(0, 288px));
    gap: 16px;
    justify-content: start;
  }
}
@media (max-width: 560px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_grid-wrap__p-A2w {
    grid-template-columns: 1fr;
    margin-top: 18px;
  }
}
@media (max-width: 560px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_search-actions__hogZC {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    margin-bottom: 10px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_search-actions__buttons__s1MmI {
    gap: 6px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_search-actions__count__Wi5UB {
    font-size: 12px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action__rtsWB:not(.ProfessionalsList_search-action--clear__zgqp4) {
    min-height: 40px;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 12px;
  }
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_search-action--clear__zgqp4 {
    min-height: 24px;
    padding-left: 2px;
    padding-right: 2px;
    font-size: 12px;
  }
}
.ProfessionalsList_professionals__6T19v .ProfessionalsList_professionals-search-override__Elmt5 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
@media (max-width: 768px) {
  .ProfessionalsList_professionals__6T19v .ProfessionalsList_professionals-search-override__Elmt5 {
    margin: 20px 0 0 !important;
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/ProfessionalsList/ProfessionalsList.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAJA;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,2BAAA;AAOF;AALE;EAPF;IAQI,2BAAA;EAQF;AACF;AANE;EAXF;IAYI,uBAAA;EASF;AACF;AAPE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AASJ;AANE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,2CAAA;EACA,qBAAA;EACA,cA5CM;EA6CN,eAAA;EACA,gBAAA;EACA,yBAAA;AAQJ;AANI;EACE,gBAAA;AAQN;AAJE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAMJ;AAJI;EACE,QAAA;EACA,SAAA;EACA,UAAA;AAMN;AAHI;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAKN;AADM;EACE,QAAA;AAGR;AAAM;EACE,QAAA;EACA,gBAAA;AAER;AACM;EACE,gBAAA;AACR;AAIE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,wCAAA;EACA,yCAAA;AAFJ;AAII;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;AAFN;AAKI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AAHN;AAOE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;EACA,6CAAA;EACA,uBAAA;EACA,8BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AALJ;AAOI;EACE,qCAAA;AALN;AAQI;EACE,6CAAA;EACA,mBAAA;AANN;AASI;EACE,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;AAPN;AASM;EACE,uBAAA;EACA,wCAAA;AAPR;AAYE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qFAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,YAAA;EACA,gBAAA;AAVN;AAaI;EACE,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAXN;AAcI;EACE,gBAAA;EACA,SAAA;EACA,8BAAA;EACA,mCAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AAZN;AAeI;EACE,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,oCAAA;EACA,gBAAA;AAbN;AAgBI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAdN;AAiBI;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;EACA,6CAAA;EACA,sCAAA;EACA,WAAA;EACA,+DAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAfN;AAiBM;EACE,4CAAA;AAfR;AAkBM;EACE,oCAAA;EACA,mBAAA;AAhBR;AAoBI;EA9EF;IA+EI,SAAA;EAjBJ;EAmBI;IACE,2BAAA;EAjBN;AACF;AAoBI;EAtFF;IAuFI,6CAAA;IACA,SAAA;EAjBJ;EAmBI;IACE,iCAAA;EAjBN;EAoBI;IACE,gBAAA;IACA,eAAA;EAlBN;EAqBI;IACE,oBAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;EAnBN;EAsBI;IACE,WAAA;EApBN;AACF;AAwBE;EACE,gBAAA;EACA,wCAAA;EACA,yCAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAtBJ;AAwBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;AAtBN;AAyBI;EAfF;IAgBI,gBAAA;EAtBJ;AACF;AAyBE;EACE,aAAA;EACA,kDAAA;EACA,SAAA;EACA,oBAAA;EACA,8BAAA;EACA,gBAAA;AAvBJ;AAyBI;EARF;IASI,kDAAA;EAtBJ;AACF;AAwBI;EAZF;IAaI,kDAAA;IACA,SAAA;IACA,sBAAA;EArBJ;AACF;AAuBI;EAlBF;IAmBI,0BAAA;IACA,gBAAA;EApBJ;AACF;AAuBE;EACE;IACE,0CAAA;IACA,SAAA;IACA,mBAAA;EArBJ;EAuBI;IACE,QAAA;EArBN;EAwBI;IACE,eAAA;EAtBN;EA2BI;IACE,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;EAzBN;EA4BI;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;EA1BN;AACF;AA8BE;EACE,wBAAA;EACA,2BAAA;AA5BJ;AA8BI;EAJF;IAKI,2BAAA;IACA,sBAAA;EA3BJ;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-bg: #EFF0EC;\n$bw-text: #13231D;\n$bw-text-secondary: rgba(19, 35, 29, 0.68);\n$bw-primary: #82B194;\n$bw-primary-hover: #709D83;\n$bw-primary-active: #527963;\n$bw-border: rgba(16, 25, 21, 0.08);\n$bw-surface: #F7F5F1;\n$bw-control-radius: 14px;\n\n.professionals {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 32px 40px 88px;\n  background-color: transparent;\n  --bw-grid-search-axis: 40px;\n\n  @media (max-width: 1164px) {\n    --bw-grid-search-axis: 28px;\n  }\n\n  @media (max-width: 860px) {\n    padding: 24px 20px 60px;\n  }\n\n  .utility-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 24px;\n  }\n\n  .back {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 42px;\n    padding: 0 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(16, 25, 21, 0.10);\n    background: rgba(248, 244, 240, 0.92);\n    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.03);\n    text-decoration: none;\n    color: $bw-text;\n    font-size: 14px;\n    font-weight: 800;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: #fff;\n    }\n  }\n\n  .professional-search-flow {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n\n    .search-holder {\n      order: 1;\n      margin: 0;\n      padding: 0;\n    }\n\n    .professional-results {\n      order: 2;\n      margin: 0;\n      padding: 0;\n      scroll-margin-top: 20px;\n    }\n\n    &.is-search-active {\n      .professional-results {\n        order: 1;\n      }\n\n      .search-holder {\n        order: 2;\n        margin-top: 24px;\n      }\n\n      .grid-wrap {\n        margin-top: 28px;\n      }\n    }\n  }\n\n  .search-actions {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 16px;\n    margin: 0 0 12px;\n    padding-left: var(--bw-grid-search-axis);\n    padding-right: var(--bw-grid-search-axis);\n\n    &__count {\n      margin: 0;\n      align-self: center;\n      min-width: 0;\n      font-size: 14px;\n      line-height: 1.5;\n      font-weight: 600;\n      color: var(--bw-text-secondary, #617067);\n    }\n\n    &__buttons {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      gap: 7px;\n    }\n  }\n\n  .search-action {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 42px;\n    padding: 0 17px;\n    border: 1px solid var(--bw-primary, #82B194);\n    border-radius: var(--bw-control-radius, 14px);\n    background: transparent;\n    color: var(--bw-text, #13231D);\n    font: 600 13px/1.4 'Sora', system-ui, -apple-system, sans-serif;\n    cursor: pointer;\n    text-align: center;\n    text-decoration: none;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: rgba(130, 177, 148, 0.09);\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--bw-primary, #82B194);\n      outline-offset: 3px;\n    }\n\n    &--clear {\n      min-height: 24px;\n      padding: 0 2px;\n      border: 0;\n      border-radius: 0;\n      background: transparent;\n      font-size: 12px;\n      font-weight: 600;\n      text-decoration: underline;\n      text-underline-offset: 3px;\n      color: var(--bw-text, #13231D);\n\n      &:hover {\n        background: transparent;\n        color: var(--bw-primary-active, #527963);\n      }\n    }\n  }\n\n  .empty-results {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    padding: clamp(28px, 3.6vw, 44px) var(--bw-grid-search-axis) clamp(30px, 3.6vw, 44px);\n    width: 100%;\n    max-width: 100%;\n    background: transparent;\n    text-align: left;\n\n    &__copy {\n      min-width: 0;\n      max-width: 760px;\n    }\n\n    &__count {\n      display: block;\n      margin: 0 0 10px;\n      color: var(--bw-primary, #82B194);\n      font-size: 12px;\n      font-weight: 700;\n      line-height: 1.45;\n      letter-spacing: 0.12em;\n      text-transform: uppercase;\n    }\n\n    h2 {\n      max-width: 580px;\n      margin: 0;\n      color: var(--bw-text, #13231D);\n      font-size: clamp(28px, 2.5vw, 36px);\n      line-height: 1.22;\n      letter-spacing: -0.035em;\n      font-weight: 700;\n      text-wrap: balance;\n    }\n\n    &__description {\n      max-width: 650px;\n      margin: 14px 0 0;\n      color: var(--bw-text-secondary, #617067);\n      font-size: clamp(15px, 1.15vw, 17px);\n      line-height: 1.6;\n    }\n\n    &__actions {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      width: 100%;\n      margin: 0;\n    }\n\n    &__primary {\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      min-height: 46px;\n      padding: 0 23px;\n      border: 1px solid var(--bw-primary, #82B194);\n      border-radius: var(--bw-control-radius, 14px);\n      background: var(--bw-primary, #82B194);\n      color: #fff;\n      font: 700 14px/1.3 'Sora', system-ui, -apple-system, sans-serif;\n      cursor: pointer;\n      white-space: nowrap;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: var(--bw-primary-hover, #709D83);\n      }\n\n      &:focus-visible {\n        outline: 2px solid var(--bw-primary);\n        outline-offset: 3px;\n      }\n    }\n\n    @media (max-width: 840px) {\n      gap: 20px;\n\n      &__actions {\n        justify-content: flex-start;\n      }\n    }\n\n    @media (max-width: 560px) {\n      padding: 24px var(--bw-grid-search-axis) 30px;\n      gap: 16px;\n\n      h2 {\n        font-size: clamp(26px, 6vw, 32px);\n      }\n\n      &__description {\n        margin-top: 12px;\n        font-size: 15px;\n      }\n\n      &__actions {\n        align-items: stretch;\n        flex-direction: column;\n        gap: 12px;\n        width: 100%;\n      }\n\n      &__primary {\n        width: 100%;\n      }\n    }\n  }\n\n  .grid-footer {\n    margin: 22px 0 0;\n    padding-left: var(--bw-grid-search-axis);\n    padding-right: var(--bw-grid-search-axis);\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    .grid-count {\n      font-size: 14px;\n      line-height: 1.5;\n      font-weight: 600;\n      color: var(--bw-text-secondary, #617067);\n    }\n\n    @media (max-width: 560px) {\n      margin-top: 17px;\n    }\n  }\n\n  .grid-wrap {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 288px));\n    gap: 16px;\n    align-items: stretch;\n    justify-content: space-between;\n    margin-top: 20px;\n\n    @media (max-width: 1180px) {\n      grid-template-columns: repeat(3, minmax(0, 288px));\n    }\n\n    @media (max-width: 980px) {\n      grid-template-columns: repeat(2, minmax(0, 288px));\n      gap: 16px;\n      justify-content: start;\n    }\n\n    @media (max-width: 560px) {\n      grid-template-columns: 1fr;\n      margin-top: 18px;\n    }\n  }\n\n  @media (max-width: 560px) {\n    .search-actions {\n      grid-template-columns: minmax(0, 1fr) auto;\n      gap: 10px;\n      margin-bottom: 10px;\n\n      &__buttons {\n        gap: 6px;\n      }\n\n      &__count {\n        font-size: 12px;\n      }\n    }\n\n    .search-action {\n      &:not(.search-action--clear) {\n        min-height: 40px;\n        padding-left: 12px;\n        padding-right: 12px;\n        font-size: 12px;\n      }\n\n      &--clear {\n        min-height: 24px;\n        padding-left: 2px;\n        padding-right: 2px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  & .professionals-search-override {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n\n    @media (max-width: 768px) {\n      margin: 20px 0 0 !important;\n      width: 100% !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"professionals": `ProfessionalsList_professionals__6T19v`,
	"utility-bar": `ProfessionalsList_utility-bar__ZlqXB`,
	"back": `ProfessionalsList_back__ekJog`,
	"professional-search-flow": `ProfessionalsList_professional-search-flow__qKXrV`,
	"search-holder": `ProfessionalsList_search-holder__c3enG`,
	"professional-results": `ProfessionalsList_professional-results__qN1mE`,
	"is-search-active": `ProfessionalsList_is-search-active__pefa4`,
	"grid-wrap": `ProfessionalsList_grid-wrap__p-A2w`,
	"search-actions": `ProfessionalsList_search-actions__hogZC`,
	"search-actions__count": `ProfessionalsList_search-actions__count__Wi5UB`,
	"search-actions__buttons": `ProfessionalsList_search-actions__buttons__s1MmI`,
	"search-action": `ProfessionalsList_search-action__rtsWB`,
	"search-action--clear": `ProfessionalsList_search-action--clear__zgqp4`,
	"empty-results": `ProfessionalsList_empty-results__Q+DHq`,
	"empty-results__copy": `ProfessionalsList_empty-results__copy__u9God`,
	"empty-results__count": `ProfessionalsList_empty-results__count__atO0T`,
	"empty-results__description": `ProfessionalsList_empty-results__description__oJCB2`,
	"empty-results__actions": `ProfessionalsList_empty-results__actions__A7-OR`,
	"empty-results__primary": `ProfessionalsList_empty-results__primary__AH7LF`,
	"grid-footer": `ProfessionalsList_grid-footer__qBgD+`,
	"grid-count": `ProfessionalsList_grid-count__IyXSg`,
	"professionals-search-override": `ProfessionalsList_professionals-search-override__Elmt5`
};
export default ___CSS_LOADER_EXPORT___;
